import { render, staticRenderFns } from "./version_menu_edit.vue?vue&type=template&id=8a39aa90&scoped=true"
import script from "./version_menu_edit.vue?vue&type=script&lang=js"
export * from "./version_menu_edit.vue?vue&type=script&lang=js"
import style0 from "./version_menu_edit.vue?vue&type=style&index=0&id=8a39aa90&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a39aa90",
  null
  
)

export default component.exports